import React, { useEffect, useRef, useState } from "react";
import { useMoneyPageStore } from "../../store/moneyPageStore.js";
import { Link } from "react-router-dom";

import moment from "moment";
import { Table, ConfigProvider, Input, Select, DatePicker } from "antd";


import images from "../../assets";
import { VioletButtonLarge } from "../../components/button";

const { RangePicker } = DatePicker;

export default function MoneyPage() {
  const { moneyPages, isLoading, getMoneyPages } = useMoneyPageStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    fetchMoneyPages();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [moneyPages, searchText, statusFilter, dateRange]);

  const fetchMoneyPages = async () => {
    getMoneyPages({});
  };

  const applyFilters = () => {
    let filtered = moneyPages;

    if (searchText) {
      filtered = filtered?.filter(
        (item) =>
          item?.pageUrl?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.pageTitle?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.metaKeyword?.toLowerCase().includes(searchText?.toLowerCase())
      );
    }

    if (statusFilter) {
      filtered = filtered?.filter((item) => item?.status === statusFilter);
    }

    if (dateRange?.length === 2) {
      const [startDate, endDate] = dateRange;
      filtered = filtered?.filter((item) => {
        const publishDate = moment(item?.createdAt);
        return publishDate?.isBetween(startDate, endDate, "days", "[]");
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleStatusChange = (value) => {
    setStatusFilter(value);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const columns = [
    {
      title: "ID",
      width: 70,
      render: (text, record) => record?.id,
      key: "1",
    },
    {
      title: "URL",
      width: 120,
      render: (text, record) => (
        <Link
          to={`https://noblemarriage.com/${record?.pageUrl}`}
          target="_blank"
        >
          {record?.pageUrl}
        </Link>
      ),
      key: "2",
    },
    {
      title: "Page Title",
      key: "3",
      width: 130,
      render: (text, record) => record?.pageTitle,
      fixed: "left",
    },
    {
      title: "Page Header",
      key: "11",
      width: 130,
      render: (text, record) => record?.pageHeader,
      fixed: "left",
    },
    {
      title: "Meta Keyword",
      key: "4",
      render: (text, record) => record?.metaKeyword,
      width: 150,
    },
    {
      title: "Meta Description",
      key: "6",
      render: (text, record) => record?.metaDescription,
      width: 150,
    },
    {
      title: "Status",
      key: "7",
      render: (text, record) => record?.status,
      width: 70,
    },
    {
      title: "Search Params",
      key: "8",
      render: (text, record) => {
        const params = record?.searchingParams || {};
        return (
          <div>
            {Object.entries(params).map(([key, value]) => (
              <div key={key}>
                <strong>{key}:</strong> {String(value)}
              </div>
            ))}
          </div>
        );
      },
      width: 150,
    },
    {
      title: "Related Search",
      key: "9",
      render: (text, record) => {
        return (
          record?.relatedSearch && (
            <div className="flex flex-wrap gap-2">
              {record?.relatedSearch?.split(",")?.map((item, index) => (
                <span
                  key={index}
                  className="bg-basePrimary p-1 rounded-lg text-white font-semibold text-[12px]"
                >
                  {item}
                </span>
              ))}
            </div>
          )
        );
      },
      width: 160,
    },
    {
      title: "Publish Date",
      key: "10",
      render: (text, record) => moment(record?.createdAt).format("DD.MM.YYYY"),
      width: 130,
    },
    {
      title: "Action",
      key: "17",
      fixed: "right",
      align: "center",
      width: 80,
      render: (text, record) => (
        <Link to={`/moneyPage/${record?.id}`}>
          <img src={images.editIcon} alt="" />
        </Link>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-4 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Status</div>
          <Select
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Filter by Status"
            onChange={handleStatusChange}
            allowClear
            options={[
              { value: "published", label: "Published" },
              { value: "draft", label: "Draft" },
            ]}
            value={statusFilter}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Date range</div>
          <RangePicker
            style={{ height: 48 }}
            className="moneyPage"
            onChange={handleDateChange}
            allowClear
          />
        </div>
        <Link to={"/addMoneyPage"} className="w-max">
          <VioletButtonLarge text="Add Money Page" />
        </Link>
      </div>
      <div>
        Total: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isLoading}
          rowKey={(record) => record?.username}
          onChange={handleTableChange}
        />
      </ConfigProvider>
    </div>
  );
}








